import {createSelector, createSlice} from "@reduxjs/toolkit";

const initialState = {};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    login(state) {
      delete state.loginErrors;
      delete state.login2faErrors;
      state.loggingIn = true;
    },
    login2fa(state) {
      delete state.login2faErrors;
      state.loggingIn = true;
    },
    loginSuccess(state, action) {
      const {token, expiry, sendeunternehmen_id: sendeunternehmenId} = action.payload;
      if (token) {
        state.data = {token, expiry, sendeunternehmenId, active: true};
      }
      delete state.loggingIn;
      delete state.login2faErrors;
      delete state.login2fa;
    },
    loginRequires2fa(state, action) {
      state.login2fa = action.payload;
      delete state.loggingIn;
    },
    login2faFailed(state, action) {
      const {errors} = action.payload;
      state.login2faErrors = errors;
      delete state.loggingIn;
    },
    loginFailed(state, action) {
      const {errors} = action.payload;
      state.loginErrors = errors;
      delete state.loggingIn;
      delete state.login2faErrors;
      delete state.login2fa;
    },
    loginReset(state, action) {
      delete state.loginErrors;
      delete state.loggingIn;
      delete state.login2faErrors;
      delete state.login2fa;
    },
    logout() {

    },
    logoutSuccess(state) {
      delete state.data;
    },
  },
});

export const {
  login,
  login2fa,
  loginSuccess,
  loginFailed,
  logout,
  logoutSuccess,
  loginRequires2fa,
  login2faFailed,
  loginReset,
} = sessionSlice.actions;

const reducers = {
  session: sessionSlice.reducer,
};
export default reducers;

const getSessionState = (state) => state.session;

export const isLoggingIn = createSelector(
  getSessionState,
  (sessionState) => sessionState.loggingIn,
);

export const getLoginErrors = createSelector(
  getSessionState,
  (sessionState) => sessionState.loginErrors,
);

export const getLogin2fa = createSelector(
  getSessionState,
  (sessionState) => sessionState.login2fa || {},
);

export const getLogin2faErrors = createSelector(
  getSessionState,
  (sessionState) => sessionState.login2faErrors,
);

export const getSessionData = createSelector(
  getSessionState,
  (sessionState) => sessionState.data || {},
);

export const isLoggedIn = createSelector(
  getSessionData,
  (sessionData) => sessionData.token !== undefined,
);

export const getSessionToken = createSelector(
  getSessionData,
  (sessionData) => sessionData.token,
);

export const isParticipationViewAvailable = createSelector(
  isLoggedIn,
  getSessionData,
  (isLoggedIn, sessionData) => !isLoggedIn || sessionData.sendeunternehmenId !== undefined,
);
